import { useState } from "react";
import { Button, Form, Input, message, Row, Col } from "antd";
import { saveThemeOptionThunk } from "../../../store/thunks/settingsThunk";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const ThemeOptions = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errors, setErrors] = useState([]);
  const [form] = Form.useForm();

  const [fileList, setFileList] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    // Read image parameters
    const reader = new FileReader();

    reader.onload = (e) => {
      const img = new Image();
      img.src = e.target.result;

      img.onload = () => {
        // Check for SVG file type
        const isSVG = file.type === "image/svg+xml";
        if (!isSVG) {
          setFileList([]);
          message.error("You can only upload SVG file!");
        } else {
          setFileList(img.src);
        }
      };
    };

    reader.readAsDataURL(file);
  };

  /*begin::call to api for creating new role*/
  const onFinish = async (values) => {
    if (!setFileList) {
      console.error("No file selected.");
      return;
    }
    
    const payload = {
      title: values?.title,
      logo: fileList,
      createdBy: "65c9916f4a76e9c64a469269",
      uploadType: "other",
      headers: {"Content-Type": "multipart/form-data"}
    };

    await dispatch(saveThemeOptionThunk(payload))
    .unwrap()
    .then((response) => {
      const imgUrl =
          process.env.REACT_APP_BACKEND + "/images/settings" + response;
        setErrors([]);
        message.success("Settings saved successfully");
        // Reset form fields
        form.resetFields();
        navigate('/dashboard');
    }).catch((err) => {
      message.error(err?.message || "Failed to fetch escalation details");
    });
  
  };

  return (
    <div className="all-content settingsContainer">
      <div className="all-table-holder">
        <Form
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ remember: true }}
          id="antdformstyle"
          form={form}
        >
          <Row className="logoWrap" gutter={[12, 12]}>
            <div className="formContainerWrap">

              <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item
                label="Logo Title"
                name="title"
                rules={[{ required: true, message: "Please enter the title!" }]}
              >
                <Input placeholder="Logo title" className="w-100 rounded-2" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24}>
              <Form.Item
                label="Upload Logo"
                name="logo"
                rules={[{ required: true, message: "Please upload the logo!" }]}
              >
                <input
                  type="file"
                  onChange={handleFileChange}
                  className="upload-list-block"
                />
              </Form.Item>
            </Col>
            </div>
            
            <div className="settingsButtons">
              <Button
                type="primary"
                htmlType="reset"
                className="defaultGreyBtn defaultBtn"
              >
                Clear
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="defaultBtn "
              >
                Submit
              </Button>
            </div>
          </Row>
        </Form>
      </div>
    </div>
  );
};
export default ThemeOptions;
